
export default {
  seo: {
    title: '课程 - SAI学术孔子学院',
    description: '探索我们从初级到高级的全面中文课程。HSK课程、商务汉语等，由专家讲师授课，提供认证证书。',
    keywords: '中文课程, HSK, 孔子学院, 学习中文, 在线课程, HSK认证, 商务汉语'
  },
  breadcrumb: {
    home: '首页',
    courses: '课程'
  },
  hero: {
    title: '我们的课程',
    subtitle: '探索为所有级别设计的广泛中文课程',
    coursesCount: '门课程',
    expertInstructors: '专家讲师',
    certification: '认证证书'
  },
  stats: {
    totalCourses: '可选课程',
    totalStudents: '注册学生',
    averageRating: '平均评分',
    yearsExperience: '年经验',
    certifiedInstructors: '认证讲师'
  },
  filters: {
    searchPlaceholder: '搜索课程...',
    level: '级别',
    category: '类别',
    mode: '学习模式',
    allLevels: '所有级别',
    allCategories: '所有类别',
    allModes: '所有模式',
    resultsFound: '个结果',
    clearAll: '清除全部',
    gridView: '网格视图',
    listView: '列表视图',
    priceRanges: {
      all: '所有价格',
      free: '免费',
      under500: '$500以下',
      '500to1000': '$500 - $1000',
      over1000: '$1000以上'
    },
    ratings: {
      all: '所有评分',
      '4plus': '4星以上',
      '4.5plus': '4.5星以上'
    },
    durations: {
      all: '所有时长',
      short: '短期 (≤8周)',
      medium: '中期 (9-16周)',
      long: '长期 (17+周)'
    },
    sortBy: {
      popularity: '最受欢迎',
      rating: '评分最高',
      priceLowToHigh: '价格：从低到高',
      priceHighToLow: '价格：从高到低',
      newest: '最新'
    }
  },
  levels: {
    beginner: '初级',
    elementary: '基础',
    intermediate: '中级',
    advanced: '高级',
    professional: '专业'
  },
  categories: {
    hsk: 'HSK',
    business: '商务',
    yct: 'YCT',
    conversation: '会话',
    culture: '文化'
  },
  modes: {
    online: '在线',
    offline: '面授',
    hybrid: '混合'
  },
  meta: {
    weeks: '周',
    hours: '小时',
    perSemester: '每学期',
    duration: '课程时长',
    level: '级别',
    mode: '学习模式',
    language: '授课语言',
    certificate: '证书'
  },
  cta: {
    viewCourse: '查看课程',
    contactUs: '联系我们',
    whatsapp: 'WhatsApp',
    title: '准备开始您的学习之旅了吗？',
    subtitle: '加入数千名与我们一起学习中文的学生'
  },
  noResults: {
    title: '未找到结果',
    message: '尝试更改搜索条件或筛选器'
  },

  // Comparison Feature
  comparison: {
    compare: '对比',
    addToCompare: '添加到对比',
    removeFromCompare: '从对比中移除',
    compareCourses: '课程对比',
    compareNow: '立即对比',
    selected: '已选择',
    clearAll: '清除全部',
    title: '课程对比',
    subtitle: '对比不同课程，选择最适合您的',
    feature: '特征',
    image: '图片',
    courseName: '课程名称',
    price: '价格',
    duration: '时长',
    level: '级别',
    rating: '评分',
    students: '学生人数',
    studyMode: '学习模式',
    certification: '证书',
    instructor: '授课教师',
    modules: '模块数',
    startDate: '开课日期',
    location: '上课地点',
    action: '操作',
    viewCourse: '查看课程',
    remove: '移除',
    close: '关闭',
    bestPrice: '最优价格',
    highestRated: '评分最高',
    maxCoursesReached: '最多可对比3门课程',
    selectCoursesToCompare: '至少选择2门课程进行对比'
  },

  // Course Detail Page
  courseOverview: '课程概述',
  learningOutcomes: '学习成果',
  courseBenefits: '课程优势',
  courseCurriculum: '课程大纲',
  curriculumDescription: '全面而系统的课程大纲，涵盖汉语学习的各个方面',
  lessons: '课时',
  targetAudience: '目标学员',
  targetAudienceDescription: '本课程专为以下人群设计',
  certification: '证书',
  certificationNote: '成功完成课程后，您将获得认证证书',
  courseInstructor: '授课教师',
  credentials: '资质',
  biography: '个人简介',
  yearsExp: '年经验',
  faq: '常见问题',
  faqDescription: '关于课程最常见问题的解答',
  stillHaveQuestions: '还有疑问？',
  contactUsForMore: '联系我们获取更多信息',
  relatedCourses: '相关课程',
  relatedCoursesDescription: '您可能感兴趣的其他课程',
  viewAllCourses: '查看所有课程',

  // Course Details Sidebar
  courseDetails: '课程详情',
  coursePrice: '课程价格',
  specialOffer: '特别优惠',
  startDate: '开课日期',
  location: '上课地点',
  instructor: '授课教师',
  moneyBackGuarantee: '退款保证',
  limitedSeats: '名额有限',
  needHelp: '需要帮助？',
  whatsappUs: 'WhatsApp联系',
  callUs: '电话咨询',

  // Actions
  enrollNow: '立即报名',
  downloadBrochure: '下载手册',
  brochureDownloading: '正在下载手册...',
  loading: '加载中...',

  // Common
  home: '首页',
  courses: '课程',
  contactUs: '联系我们',
  chineseLearning: '汉语学习',
  siteTitle: 'SAI学术学院',
  students: '名学生',

  // Course Badges
  badges: {
    hsk: 'HSK',
    diploma: '文凭',
    scholarship: '奖学金',
    certified: '认证',
    online: '在线',
    offline: '面授',
    hybrid: '混合'
  },

  // Module/Lesson Terms
  module: '模块',
  lesson: '课',
  modules: '个模块',

  // Time Units
  weeks: '周',
  months: '月',
  hours: '小时',

  // Course Info Labels
  enrolled: '已报名',
  rating: '评分',
  reviews: '条评价',

  // SEO Templates for Individual Courses
  courseSeoTitle: '{courseName} - SAI学术学院 | 孔子学院',
  courseSeoDescription: '在SAI学术学院跟随专家讲师学习{courseName}。全面的{level}课程，提供认证证书。立即报名！',
  courseSeoKeywords: '{courseName}, 学习中文, HSK, 孔子学院, 中文课程, SAI学术, 萨那, 也门',

  // Enrollment Form
  enrollment: {
    title: '课程报名',
    courseLabel: '所选课程',
    fullName: '姓名',
    fullNamePlaceholder: '请输入您的姓名',
    email: '电子邮件',
    emailPlaceholder: 'example@email.com',
    phone: '电话号码',
    phonePlaceholder: '+967 777 123 456',
    studyMode: '首选学习模式',
    studyModePlaceholder: '选择学习模式',
    studyModes: {
      online: '在线',
      offline: '面授',
      hybrid: '混合（在线 + 面授）',
    },
    preferredStartDate: '首选开课日期',
    chineseLevel: '当前汉语水平',
    chineseLevelPlaceholder: '选择您的当前水平',
    levels: {
      none: '无基础',
      beginner: '初学者（会一些词汇）',
      hsk1: 'HSK 1',
      hsk2: 'HSK 2',
      hsk3: 'HSK 3',
      hsk4: 'HSK 4',
      hsk5: 'HSK 5',
      hsk6: 'HSK 6',
    },
    message: '补充说明',
    messagePlaceholder: '如有其他信息，欢迎告知我们...',
    privacyNote: '您的信息受到保护，不会与任何第三方共享。我们的团队将在24小时内与您联系。',
    submit: '提交报名申请',
    submitting: '提交中...',
    cancel: '取消',
    close: '关闭',
    successTitle: '申请提交成功！🎉',
    successMessage: '感谢您对本课程的报名兴趣。我们的团队将在24小时内与您联系，确认您的报名并指导您完成后续步骤。',
    errors: {
      fullNameRequired: '姓名为必填项',
      emailRequired: '电子邮件为必填项',
      emailInvalid: '电子邮件格式无效',
      phoneRequired: '电话号码为必填项',
      phoneInvalid: '电话号码格式无效',
      studyModeRequired: '请选择学习模式',
      startDateRequired: '请选择开课日期',
      chineseLevelRequired: '请选择您的当前水平',
    },
  },

  // YCT Program Page
  yct: {
    hero: {
      title: '青少年汉语考试（YCT）项目',
      subtitle: '儿童和青少年学习中文的有趣旅程',
      description: '青少年汉语考试（YCT）是专为6至15岁青少年学习者设计的国际标准化汉语水平考试。',
      enrollButton: '立即为您的孩子报名',
      learnMoreButton: '了解更多'
    },
    whatIsYCT: {
      title: '什么是YCT？',
      description: '青少年汉语考试（YCT）是一项国际标准化汉语水平考试。它评估青少年学生在日常生活和学术生活中使用汉语的能力。',
      levels: {
        title: 'YCT等级',
        level1: {
          name: 'YCT一级',
          description: '80个词汇 - 非常适合刚开始中文学习之旅的初学者',
          vocabulary: '80个词汇'
        },
        level2: {
          name: 'YCT二级',
          description: '150个词汇 - 用基本词汇和短语打下坚实的基础',
          vocabulary: '150个词汇'
        },
        level3: {
          name: 'YCT三级',
          description: '300个词汇 - 扩展日常对话的语言技能',
          vocabulary: '300个词汇'
        },
        level4: {
          name: 'YCT四级',
          description: '600个词汇 - 掌握中文以实现自信交流',
          vocabulary: '600个词汇'
        }
      }
    },
    benefits: {
      title: '为什么选择我们的YCT项目？',
      benefit1: {
        title: '有趣互动的学习',
        description: '专为年轻学习者设计的游戏、活动和多媒体互动课程'
      },
      benefit2: {
        title: '国际认可证书',
        description: '获得全球认可的官方YCT证书'
      },
      benefit3: {
        title: '适龄教学',
        description: '专门针对儿童认知发展阶段设计的课程'
      },
      benefit4: {
        title: '专家讲师',
        description: '专门从事儿童汉语教学的经验丰富的教师'
      },
      benefit5: {
        title: '小班授课',
        description: '小班教学，个性化关注，效果最佳'
      },
      benefit6: {
        title: '灵活时间',
        description: '在线和面授学习选项，适合您家庭的时间安排'
      }
    },
    ageGroups: {
      title: '目标年龄组',
      group1: {
        age: '6-12岁',
        title: '儿童',
        description: '非常适合开始中文学习之旅的小学生',
        levels: 'YCT一级至三级'
      },
      group2: {
        age: '13-15岁',
        title: '青少年',
        description: '专为希望深化中文技能的中学生设计',
        levels: 'YCT三级至四级'
      }
    },
    curriculum: {
      title: '课程概览',
      description: '我们的YCT项目遵循结构化课程，逐步培养语言技能',
      level1: {
        title: 'YCT一级',
        topics: [
          '基本问候和介绍',
          '数字和颜色',
          '家庭成员',
          '常见动物和食物',
          '简单的日常活动'
        ]
      },
      level2: {
        title: 'YCT二级',
        topics: [
          '时间和日期',
          '天气和季节',
          '爱好和兴趣',
          '学校生活',
          '购物和价格'
        ]
      },
      level3: {
        title: 'YCT三级',
        topics: [
          '描述人和地方',
          '表达偏好',
          '谈论过去的经历',
          '提出建议',
          '理解简单文本'
        ]
      },
      level4: {
        title: 'YCT四级',
        topics: [
          '复杂对话',
          '表达观点',
          '理解中国文化',
          '高级阅读和写作',
          'HSK考试准备'
        ]
      }
    },
    instructor: {
      title: '认识您的老师',
      name: '李小梅',
      role: '首席YCT讲师',
      bio: '李老师拥有超过10年的儿童汉语教学经验，专门让语言学习变得有趣和引人入胜。她拥有对外汉语教学学位，热衷于帮助年轻学生发现中文语言和文化之美。',
      qualifications: [
        '对外汉语教学硕士',
        'YCT教学认证',
        '10年以上教学经验',
        '专攻儿童教育'
      ]
    },
    testimonials: {
      title: '家长评价',
      testimonial1: {
        text: '我女儿非常喜欢YCT课程！李老师让学习变得非常有趣，她的中文在短短几个月内就有了显著提高。',
        parent: 'Sarah Ahmed',
        relation: 'YCT二级学生家长'
      },
      testimonial2: {
        text: '非常适合孩子的优秀项目！课程设计得很好，老师们耐心且专业。我儿子期待每一节课。',
        parent: 'Mohammed Ali',
        relation: 'YCT三级学生家长'
      },
      testimonial3: {
        text: '对我女儿教育的最佳投资。她以优异的成绩通过了YCT一级考试，现在说中文很自信。',
        parent: 'Fatima Hassan',
        relation: 'YCT一级学生家长'
      }
    },
    faq: {
      title: '常见问题',
      question1: {
        q: '开始YCT项目的合适年龄是多少？',
        a: 'YCT项目专为6至15岁的儿童设计。我们建议没有中文基础的6-8岁儿童从YCT一级开始。'
      },
      question2: {
        q: '课程多久上一次？',
        a: '我们提供灵活的时间安排选项。通常，我们建议每周上2-3节课，每节课60分钟，以获得最佳效果。'
      },
      question3: {
        q: '我的孩子需要任何先前经验吗？',
        a: '不需要，YCT一级是为完全初学者设计的。您的孩子将从基础开始，逐步进步。'
      },
      question4: {
        q: '需要什么材料？',
        a: '我们提供所有学习材料，包括教科书、工作表和在线资源。您只需要一个笔记本和笔来做作业。'
      },
      question5: {
        q: '我的孩子什么时候可以参加YCT考试？',
        a: '官方YCT考试每年举行几次。根据您孩子的进度，我们会在他们准备好时推荐考试日期。'
      },
      question6: {
        q: '你们提供在线课程吗？',
        a: '是的！我们提供面授和在线课程。我们的在线课程与面授课程一样互动和引人入胜。'
      }
    },
    cta: {
      title: '准备好开始您孩子的中文学习之旅了吗？',
      description: '今天就加入我们的YCT项目，给您的孩子语言掌握和文化意识的礼物',
      enrollButton: '立即报名',
      contactButton: '联系我们'
    }
  }
};
